import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Container from "@mui/material/Container";
import { Button, Typography, useTheme } from "@mui/material";
import Slider from "@mui/material/Slider";
import IconButton from "@mui/material/IconButton";
import DotIcon from "@mui/icons-material/FiberManualRecord";
import Avatar from "@mui/material/Avatar";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import OnioTabs from "../../Components/OnioTabs";
import "./index.css";
import ArrowIcon from "../../../assets/Icons/Arrow Up-01.png";
import MuteIcon from "../../../assets/Icons/Mute White.png";
import MuteIconRed from "../../../assets/Icons/Mute Red-01.png";
import {
  Menus,
  CardTitle,
  IconButtonStyle,
  VolumeIconsStyle,
  silderMarks,
  VolumePanels,
  volumeGridStyle
} from "./style";

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#212121",
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  [theme.breakpoints.up("md")]: {
    width: 384,
  },
  [theme.breakpoints.down("md")]: {
    width: 384,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  height: 495,
  borderRadius: "15px",
}));

const ButtonItem = styled(Button)(({ theme }) => ({
  color: "#909090",
  fontSize: 16,
  fontWeight: 400,
  textTransform: "capitalize",
  ":active": {
    color: "#E7F011",
  },
}));


const AudioPage = () => {

  const theme = useTheme();
  const [selectedMenu, setSelectedmenu] = useState<number>(0);

  const [volume1, setVolume1] = useState<number>(75);
  const [volume2, setVolume2] = useState<number>(50);

  const [previousVolume, setPreviousVolume] = useState<VolumePanels>({ pv1: 0, pvStatus1: false, pv2: 0, pvStatus2: false });
  const [tab, setTab] = useState<number>(0);

  const handleMenuNavigation = (ele: any, i: number) => {
    setTab(i)
  }
  const menuHandler = (ele: any, i: number) => {
    setSelectedmenu(i);
  };
  const setSliderColor = (value: number) => {
    if (value <= 60) {
      return "rgba(51, 255, 0, 1) 0%"
    } else if (value > 60 && value < 90) {
      return "linear-gradient(360deg, rgba(51,255,0,1) 60%, rgba(219,255,0,1) 100%)"
    } else if (value >= 90) {
      return "linear-gradient(360deg, rgba(51,255,0,1) 0%, rgba(173,255,0,1) 80%, rgba(255,0,0,1) 100%)"
    } else if (value === 0) {
      return "none"
    }
  }
  const theme1 = createTheme({
    components: {
      MuiSlider: {
        styleOverrides: {
          track: {
            background: setSliderColor(volume1),
            display: volume1 <= 0 ? "none" : ""
          },
        },
      },
    },
  });
  const theme2 = createTheme({
    components: {
      MuiSlider: {
        styleOverrides: {
          track: {
            background: setSliderColor(volume2),
            display: volume2 <= 0 ? "none" : ""
          },
        },
      },
    },
  });

  const handleChange = (event: Event, newValue: number | number[]) => {
    let target = event.target as HTMLInputElement;
    if (target.name === "panel-1") {
      setVolume1(newValue as number);
      return;
    } else if (target.name === "panel-2") {
      setVolume2(newValue as number);
      return;
    }
  };
  const handleVolumeUp = (panel: number) => {
    switch (panel) {
      case 1:
        if (volume1 < 100) {
          setVolume1(volume1 + 3);
        }
        break;
      case 2:
        if (volume2 < 100) {
          setVolume2(volume2 + 3);
        }
        break;
    }
  };
  const handleVolumeDown = (panel: number) => {
    switch (panel) {
      case 1:
        if (volume2 > 0) {
          setVolume1(volume1 - 3);
        }
        break;
      case 2:
        if (volume2 > 0) {
          setVolume2(volume2 - 3);
        }
        break;
    }
  };

  const handleMute = (panel: number) => {
    switch (panel) {
      case 1:
        if (!previousVolume.pvStatus1) {
          setPreviousVolume(previousVolume => { return { ...previousVolume, pvStatus1: true, pv1: volume1 } })
          setVolume1(0)
        } else if (previousVolume.pvStatus1) {
          setPreviousVolume(previousVolume => { return { ...previousVolume, pvStatus1: false } })
          setVolume1(previousVolume.pv1)
        }
        break;
      case 2:
        if (!previousVolume.pvStatus2) {
          setPreviousVolume(previousVolume => { return { ...previousVolume, pvStatus2: true, pv2: volume2 } })
          setVolume2(0)
        } else if (previousVolume.pvStatus2) {
          setPreviousVolume(previousVolume => { return { ...previousVolume, pvStatus2: false } })
          setVolume2(previousVolume.pv2)
        }
        break;
    }
  };
  return (
    <Container maxWidth="md">
      <OnioTabs menu={Menus} onClick={handleMenuNavigation} />

      <Grid container spacing={4} sx={{ mt: 1 }}>
        <Grid ip={12} il={6} sx={volumeGridStyle(theme)}  >
          <Item>
            <Typography sx={CardTitle}>Dining Table</Typography>
            <Grid container sx={{ paddingTop: "25px" }}>
              <Grid xs={4} md={4} className="base-slider">
                <div className="baseLabels">
                  {silderMarks.map((ele) => {
                    return <span key={ele.value}>{ele.label} </span>;
                  })}
                </div>
                <ThemeProvider theme={theme1}>
                  <Slider
                    sx={{ height: 361, width: 30 }}
                    orientation="vertical"
                    value={volume1}
                    defaultValue={100}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    disabled
                  />
                </ThemeProvider>
              </Grid>
              <Grid xs={4} md={4} className="volumeSlider">
                <Slider
                  sx={{ height: 361, color: "#2DAAE1" }}
                  onChange={handleChange}
                  value={volume1}
                  name="panel-1"
                  orientation="vertical"
                  defaultValue={50}
                  aria-label="Default"
                  valueLabelDisplay="auto"

                />
              </Grid>
              <Grid xs={4} md={4} sx={VolumeIconsStyle}>
                <IconButton
                  onClick={() => handleVolumeUp(1)}
                  sx={IconButtonStyle}
                  size="large"
                >
                  <Avatar
                    variant="square"
                    alt="Remy Sharp"
                    src={ArrowIcon}
                    sx={{ width: 60, height: 60 }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => handleMute(1)}
                  sx={IconButtonStyle}
                  size="large"
                >
                  <Avatar
                    variant="square"
                    alt="Remy Sharp"
                    src={previousVolume.pvStatus1 ? MuteIconRed : MuteIcon}
                    sx={{ width: 60, height: 60 }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => handleVolumeDown(1)}
                  sx={IconButtonStyle}
                  size="large"
                >
                  <Avatar
                    variant="square"
                    alt="Remy Sharp"
                    src={ArrowIcon}
                    sx={{ width: 60, height: 60, transform: "rotate(180deg)" }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Item>
        </Grid>
        <Grid ip={12} il={6} sx={volumeGridStyle(theme)} >
          <Item>
            <Typography sx={CardTitle}>Chill Zone</Typography>
            <Grid container sx={{ paddingTop: "25px" }}>
              <Grid xs={4} md={4} className="base-slider">
                <div className="baseLabels">
                  {silderMarks.map((ele) => {
                    return <span key={ele.label}>{ele.label} </span>;
                  })}
                </div>
                <ThemeProvider theme={theme2}>
                  <Slider
                    sx={{ height: 361, width: 30 }}
                    orientation="vertical"
                    defaultValue={volume2}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    value={volume2}
                    disabled
                  />
                </ThemeProvider>
              </Grid>
              <Grid xs={4} md={4} className="volumeSlider">
                <Slider
                  sx={{ height: 361, color: "#2DAAE1" }}
                  onChange={handleChange}
                  name="panel-2"
                  value={volume2}
                  size="medium"
                  orientation="vertical"
                  defaultValue={50}
                  aria-label="Default"
                  valueLabelDisplay="auto"
                />
              </Grid>
              <Grid xs={4} md={4} sx={VolumeIconsStyle}>
                <IconButton
                  onClick={() => handleVolumeUp(2)}
                  sx={IconButtonStyle}
                  size="large"
                >
                  <Avatar
                    variant="square"
                    alt="Remy Sharp"
                    src={ArrowIcon}
                    sx={{ width: 60, height: 60 }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => handleMute(2)}
                  onMouseDown={() => console.log('long press')}
                  sx={IconButtonStyle}
                  size="large"
                >
                  <Avatar
                    variant="square"
                    alt="Remy Sharp"
                    src={previousVolume.pvStatus2 ? MuteIconRed : MuteIcon}
                    sx={{ width: 60, height: 60 }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => handleVolumeDown(2)}
                  sx={IconButtonStyle}
                  size="large"
                >
                  <Avatar
                    variant="square"
                    alt="Remy Sharp"
                    src={ArrowIcon}
                    sx={{ width: 60, height: 60, transform: "rotate(180deg)" }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AudioPage;
